import { Link } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import s from './SettingsPage.module.css';

/* -------------------------------------------------------------------------- */
/*  SettingsPage                                                               */
/* -------------------------------------------------------------------------- */

export default function SettingsPage() {
  const { user } = useAuth();

  if (!user) {
    return <div className={s.loading}>Loading&hellip;</div>;
  }

  const currentTenant = user.tenants.find((t) => t.id === user.currentTenantId);

  return (
    <>
      {/* Header */}
      <div className={s.header}>
        <h1 className={s.title}>Settings</h1>
      </div>

      {/* Organization section */}
      <div className={s.section}>
        <div className={s.sectionTitle}>Organization</div>

        <div className={s.infoRow}>
          <div className={s.infoLabel}>Name</div>
          <div className={s.infoValue}>
            {currentTenant?.name ?? '—'}
          </div>
        </div>

        <div className={s.infoRow}>
          <div className={s.infoLabel}>Slug</div>
          <div className={s.infoValueMono}>
            {currentTenant?.id ?? '—'}
          </div>
        </div>

        <div className={s.infoRow}>
          <div className={s.infoLabel}>Plan</div>
          <div className={s.infoValue}>
            <span className={s.planBadge}>Free</span>
          </div>
        </div>
      </div>

      {/* Team Members section */}
      <div className={s.section}>
        <div className={s.sectionTitle}>Team Members</div>

        <div className={s.tableWrap}>
          <table className={s.table}>
            <thead>
              <tr>
                <th>Email</th>
                <th>Role</th>
                <th>Last Login</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {/* Current user row */}
              <tr>
                <td>{user.email}</td>
                <td>
                  <span className={user.role === 'owner' ? s.roleOwner : s.roleBadge}>
                    {user.role}
                  </span>
                </td>
                <td style={{ fontSize: 'var(--text-xs)', color: 'var(--text-tertiary)' }}>
                  Just now
                </td>
                <td>&mdash;</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className={s.sectionActions}>
          <button type="button" className={s.btnGhost} disabled>
            Invite User
          </button>
        </div>
      </div>

      {/* Your Account section */}
      <div className={s.section}>
        <div className={s.sectionTitle}>Your Account</div>

        <div className={s.infoRow}>
          <div className={s.infoLabel}>Email</div>
          <div className={s.infoValue}>{user.email}</div>
        </div>

        <div className={s.infoRow}>
          <div className={s.infoLabel}>Passkeys</div>
          <div className={s.infoValue} style={{ color: 'var(--text-tertiary)' }}>
            Not configured
          </div>
        </div>

        <div className={s.sectionActions}>
          <button type="button" className={s.btnGhost}>
            Change Password
          </button>
        </div>
      </div>

      {/* Billing link */}
      <Link to="/app/settings/billing" className={s.billingLink}>
        Manage Billing &rarr;
      </Link>
    </>
  );
}
